import axios from 'axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const getAllSchedules = uuid => {
  return axios.request({
    baseURL,
    url: `/v1/schedules/${uuid}`,
    method: 'GET',
  });
};

export const deleteScheduleAssembly = (uuid, data) => {
  return axios.request({
    baseURL,
    url: `/v1/schedules/${uuid}`,
    method: 'DELETE',
    data,
  });
};

export const getScheduleDetailsByUuid = uuid => {
  return axios.request({
    baseURL,
    url: `/v1/schedules/${uuid}/details`,
    method: 'GET',
  });
};

export const getAvailableDates = uuid => {
  return axios.request({
    baseURL,
    url: `/v1/schedules/${uuid}/availabledates`,
    method: 'GET',
  });
};
